import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';

import { readDeposits } from 'apis/restaurant-api/merchant-admin/deposits/api';

const emptyOption = { value: '', label: '-' };

export default function useDeposits(countryCode: Country, isDepositEnabled: boolean) {
  const { data: deposits } = useQuery(
    ['v1/merchant-admin/deposit_permutations', countryCode],
    () => readDeposits(countryCode),
    {
      refetchOnMount: false,
      enabled: isDepositEnabled,
    },
  );

  const data = useMemo(
    () =>
      deposits
        ? [
            emptyOption,
            ...deposits.map(deposit => ({
              value: deposit.id.$oid,
              label: `${parseFloat(deposit.amount.amount).toLocaleString(undefined, {
                style: 'currency',
                currency: deposit.amount.currency,
                currencyDisplay: 'symbol',
              })} (${deposit.vat_percentage}%)`,
            })),
          ]
        : [emptyOption],
    [deposits],
  );

  return { data };
}
